import React, { useState, useEffect } from 'react';
import { List, Pagination, Radio, Button, Input, Select, Icon, Divider } from 'antd';
import { ContactModal } from '../../ContactModal';
import { Contact } from '../../../../models';
import { alertify, handleApiExceptions } from '../../../../app_methods';
import { Text4 } from '../../../../styles';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../../redux/actions';


const ContactList = (props) => {
    const [contacts, setContacts] = useState([]);
    const [pagination, setPagination] = useState({
        pageSize: 10,
        total: 0,
        current: 1
    });
    const [isCreating, setIsCreating] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);
    const [filters, setFilters] = useState({ key: "name", value: "" });

    const fetchContacts = async (_pagination, _filters) => {
        if (!props.current_user.key) return;
        props.setIsLoading(true);
        const response = await Contact.list({ pageSize: _pagination.pageSize, current: _pagination.current, [_filters.key]: _filters.value });
        if (!response.success) {
            handleApiExceptions(response);
            props.setIsLoading(false);
            return;
        }
        setContacts(response.data.results);
        setPagination({ ...pagination, total: response.data.count });
        props.setIsLoading(false);
    };

    const saveContact = async (values) => {
        setIsCreating(true);
        const contact = new Contact(values);
        const response = await contact.save();
        if (!response.success) {
            setIsCreating(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", `Contact created successfully.`, "success");
        toggleContactModal();
        setIsCreating(false);
        fetchContacts(pagination, filters);
    };

    const toggleContactModal = () => {
        setShowContactModal(!showContactModal);
    };

    const handleContactSelection = (e) => {
        props.handleContactSelection(contacts.find(c => c.id == e.target.value));
    };

    const handlePaginationChange = (e) => {
        const _pagination = { ...pagination, current: e };
        setPagination(_pagination);
        fetchContacts(_pagination, filters);
    };

    const handleFiltersChange = (e, type) => {
        let _filters = { ...filters };
        switch(type){
            case "input":
                _filters.value = e.target.value;
                break;
            case "select":
                _filters.key = e;
                break;
            default:
                return;
        }
        setFilters(_filters);
    };
 
    useEffect(() => {
        fetchContacts(pagination, filters);
    }, []);
    
    const renderHeader = () => {
        return (
            <div className="mb-2 w-100 d-flex justify-content-between align-items-center">
                <div className="d-flex">
                    <Select style={{ minWidth: 100 }} size="small" value={filters.key} className="mr-1" onChange={(e) => handleFiltersChange(e, "select")}>
                        <Select.Option value="name">Name</Select.Option>
                        <Select.Option value="email">Email ID</Select.Option>
                        <Select.Option value="phone">Phone No.</Select.Option>
                    </Select>
                    <Input autoComplete='off' size="small" value={filters.value} onChange={(e) => handleFiltersChange(e, "input")} onPressEnter={() => fetchContacts(pagination, filters)} />
                    <Button className="ml-1" size="small" type="primary" onClick={() => fetchContacts(pagination, filters)}><Icon type="search" /></Button>
                </div>
                <Button type="link" onClick={toggleContactModal}><Icon type="plus" /> New Contact</Button>
            </div>
        )
    };

    const renderContacts = () => {
        return (
            <Radio.Group className="w-100 mb-2" value={props.selectedContact && props.selectedContact.id} onChange={handleContactSelection}>
                <List
                    className="w-100"
                    dataSource={contacts}
                    renderItem={item => (
                        <List.Item>
                            <div>
                                <Radio value={item.id}>
                                    <Text4 strong>{item.name}</Text4>
                                    <Text4 className="ml-1" type="secondary">・ {item.email}</Text4>
                                    <Text4 className="ml-1" type="secondary">・ {item.phone}</Text4>
                                </Radio>
                            </div>
                        </List.Item>
                    )}
                />
            </Radio.Group>
        )
    };

    const renderPagination = () => {
        return (
            <div className="d-flex justify-content-end">
                <Pagination
                    size="small"
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    current={pagination.current}
                    onChange={handlePaginationChange}
                />
            </div>
        )
    };

    return (
        <div>
            {renderHeader()}
            {renderContacts()}
            {renderPagination()}
            <ContactModal
                visible={showContactModal}
                toggleContactModal={toggleContactModal}
                saveContact={saveContact}
                loading={isCreating}
            />
        </div>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactList);